import { RouterView } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

export const storefrontRoutes: RouteRecordRaw[] = [
  {
    path: '/online-shop',
    component: RouterView,
    children: [
      {
        name: 'storefrontSettings',
        path: 'settings',
        component: () => import('@/modules/storefront/views/StorefrontSettingsView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      },
      {
        name: 'storefrontCheckout',
        path: 'checkout',
        component: () => import('@/modules/storefront/views/StorefrontCheckoutView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      },
      {
        name: 'storefrontReminders',
        path: 'messages-reminders',
        component: () => import('@/modules/storefront/views/StorefrontRemindersView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      }
    ]
  }
]
